module.exports = __webpack_public_path__ + "img/4c1c927.png";